import { render, staticRenderFns } from "./FluxoCaixaSaldoContas.vue?vue&type=template&id=b928c244&scoped=true&"
import script from "./FluxoCaixaSaldoContas.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixaSaldoContas.vue?vue&type=script&lang=js&"
import style0 from "./FluxoCaixaSaldoContas.vue?vue&type=style&index=0&id=b928c244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b928c244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
